import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/Hotel/tab/Gallery/Views/gallery.html';
import {hotelService} from '@/Pages/Admin/Modules/Hotel/Services/HotelService';
import {hotelApi} from '@/Pages/Admin/Modules/Hotel/Services/HotelApi';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import UploadFile from '@/Pages/Admin/Modules/Common/Controllers/UploadAny';
import {HotelImageModel} from '@/Pages/Admin/Modules/Models/Hotel/HotelImageModel';

@WithRender
@Component({
    components: {
        UploadFile,
    }
})
export default class HotelGallery extends Vue {
    protected ui: any = {};
    protected item: any = {};
    protected vars: any = {};

    constructor() {
        super();
        this.ui = {
            index: {
                selected: -1,
            },
            status: {
                isLoading: {
                    getImageList: false,
                },
                postLoading: {
                    setBannerImage: false,
                    deleteImage: false,
                },
                fileupload: false,
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
            },
        };

        this.item = {
            imageList: new HotelImageModel({}),
            selectedImage: new HotelImageModel({}),
        };

        this.vars = {
            titles: {
                btn_title: 'Upload Image',
                modal_title: 'Upload Image',
                browse_title: 'Browse Image File',
                document_title: 'Title or description for the Upload Image',
            },
            limitdata: {
                extensions: 'jpg|jpeg|bmp|png',
                maxSizeInMB: '10',
                fileType: '',
                invalidSizeMsg: 'Exceeded maximum File Upload  size 1 MB',
                invalidFileTypeMsg: 'Only Jpeg, png files are supported',
                titleRequiredMsg: 'Title field is required.',
            },
            postdata: {
                post_url: '',
                checkTitle: true,
            },
        };
    }

    public mounted() {
        this.getAllImageList();
    }

    public async getAllImageList() {
        this.ui.status.isLoading.getImageList = true;
        let data = {
            hotel_id: this.$route.query.id
        };
        hotelService
            .allImageList(data)
            .then((res: any) => {
                this.item.imageList = res.data.data;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.has_error = true;
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.getImageList = false;
            });
    }

    // set Banner image
    public setBannerImage(index: any, image: any) {
        this.resetError();
        let data = {
            hotel_id: this.$route.query.id,
            id: image.id
        };
        this.ui.status.postLoading.setBannerImage = true;
        hotelService
            .makeBannerImage(data)
            .then((res: any) => {
                this.getAllImageList();
                flashService.Success('Banner Image Created', res.data.message);
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.has_error = true;
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.setBannerImage = false;
            });
    }

    public hidedeleteModal() {
        this.resetError();
        $('#deleteHotelImage').modal('hide');
        $('.modal-backdrop').remove();
    }

    // Delete Image
    protected deleteModal(index: any, Image: any) {
        $('#deleteHotelImage').modal('show');
        this.item.selectedImage = Image;
        this.ui.index.selected = index;
    }

    protected deleteImage() {
        this.resetError();
        let data = {
            hotel_id: this.$route.query.id,
            id: this.item.selectedImage.id,
        };
        this.ui.status.postLoading.deleteImage = true;
        hotelService
            .deleteImage(data)
            .then((res: any) => {
                this.$delete(this.item.imageList, this.ui.index.selected);
                flashService.Success('Image Deleted', res.data.message);
                this.hidedeleteModal();
            })
            .catch((error: any) => {
                this.ui.error.has_error = true;
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.has_error = true;
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.deleteImage = false;
            });
    }

    // Image upload Section
    protected documentUploaded(data: any) {
        if (data.file_type === 'image/png' || 'image/jpeg' || 'image/jpg') {
            this.item.imageList.unshift(data);
        }
    }
     
     protected onUploadHotelImage(uploadType: string) {
        this.vars.postdata.post_url = hotelApi.AddGalleryImage();
        this.vars.postdata.uploadType = uploadType;
        if (uploadType === 'image') {
            this.vars.titles.btn_title = 'Upload Hotel';
            this.vars.titles.browse_title = 'Browse Image';
            this.vars.titles.modal_title = 'Upload Image';
        }
        this.ui.status.fileupload = true;
        this.vars.postdata.hotel_id = this.$route.query.id.toString();
    }


    protected async closeUploadModal() {
        this.ui.status.fileupload = false;
    }

    public resetError() {
        this.ui.error.errors = {};
        this.ui.error.has_error = false;
        this.ui.error.error_message = {};
    }
}
